module.exports = __webpack_public_path__ + "img/loading-spinner-small.c4e18942.svg";